import { Skeleton, Typography } from '@mui/material';

import { MarketplaceV1 } from '@jebel/constants';

import { LoadingOverlay } from 'shared/components/ui';
import { UserInfoFragment } from 'shared/graphql';

import { UserMembershipsListItem } from '../UserMembershipsListItem';
import { Container } from './UserMembershipsList.styles';

interface Props {
  /**
   * The user to display.
   */
  user: UserInfoFragment | null | undefined;

  /**
   * The memberships to display.
   */
  memberships: Array<MarketplaceV1.UserCommunityMembership> | undefined;

  /**
   * The number of skeletons to display.
   * @default 2
   */
  skeletonCount?: number;

  /**
   * Whether the memberships are loading.
   */
  isLoading: boolean;
}

export function UserMembershipsList({
  user,
  memberships = [],
  skeletonCount = 2,
  isLoading,
}: Props) {
  if (!isLoading && memberships.length === 0) {
    return (
      <Typography color="textSecondary" align="center">
        No memberships found
      </Typography>
    );
  }

  return (
    <Container>
      <LoadingOverlay
        loading={isLoading}
        overlay={Array.from({ length: skeletonCount }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" width="100%" height="4rem" />
        ))}
      >
        {memberships.map(membership => (
          <UserMembershipsListItem
            key={membership.id}
            user={user}
            status={membership.status}
            membership={membership.membership}
          />
        ))}
      </LoadingOverlay>
    </Container>
  );
}
